import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal-900 text-white pt-20 pb-10 border-t border-white/10" data-id="element-95">
      <div className="max-w-7xl mx-auto px-6" data-id="element-96">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-97">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-98">
            <div className="mb-6" data-id="element-99">
              <img src="https://cdn.magicpatterns.com/uploads/94HkoSwW7cGF2C7tNPrpQP/newplamw-e1769801367696.webp" alt="PlaneSmart" className="h-14 w-auto object-contain" data-id="element-100" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-101">
              Redefining private aviation with unparalleled service, safety, and
              transparency. Your journey, elevated.
            </p>
            <div className="flex gap-4" data-id="element-102">
              {[Facebook, Twitter, Linkedin, Instagram].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-600 transition-colors" data-id="element-103">
                  <Icon className="w-4 h-4" data-id="element-104" />
                </a>)}
            </div>
          </div>

          {/* Links */}
          <div data-id="element-105">
            <h4 className="text-lg font-serif font-semibold mb-6" data-id="element-106">Services</h4>
            <ul className="space-y-3 text-gray-400 text-sm" data-id="element-107">
              <li data-id="element-108">
                <Link to="/fly-with-us" className="hover:text-brand-400 transition-colors" data-id="element-109">
                  Charter Flights
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/owner-services" className="hover:text-brand-400 transition-colors" data-id="element-111">
                  Aircraft Management
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/brokerage" className="hover:text-brand-400 transition-colors" data-id="element-113">
                  Brokerage & Sales
                </Link>
              </li>
              <li data-id="element-114">
                <Link to="/training" className="hover:text-brand-400 transition-colors" data-id="element-115">
                  Flight Training
                </Link>
              </li>
              <li data-id="element-116">
                <Link to="/empty-legs" className="hover:text-brand-400 transition-colors" data-id="element-117">
                  Empty Legs
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-118">
            <h4 className="text-lg font-serif font-semibold mb-6" data-id="element-119">Company</h4>
            <ul className="space-y-3 text-gray-400 text-sm" data-id="element-120">
              <li data-id="element-121">
                <Link to="/discover" className="hover:text-brand-400 transition-colors" data-id="element-122">
                  About Us
                </Link>
              </li>
              <li data-id="element-123">
                <Link to="/fly-with-us" className="hover:text-brand-400 transition-colors" data-id="element-124">
                  Our Fleet
                </Link>
              </li>
              <li data-id="element-125">
                <Link to="/discover" className="hover:text-brand-400 transition-colors" data-id="element-126">
                  Safety Standards
                </Link>
              </li>
              <li data-id="element-127">
                <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-128">
                  Careers
                </a>
              </li>
              <li data-id="element-129">
                <Link to="/contact" className="hover:text-brand-400 transition-colors" data-id="element-130">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-131">
            <h4 className="text-lg font-serif font-semibold mb-6" data-id="element-132">
              Contact Us
            </h4>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-133">
              <li data-id="element-134">
                <p className="text-white font-medium mb-1" data-id="element-135">Phone</p>
                <a href="tel:1-888-228-4283" className="hover:text-brand-400 transition-colors" data-id="element-136">
                  1-888-2AVIATE (228-4283)
                </a>
              </li>
              <li data-id="element-137">
                <p className="text-white font-medium mb-1" data-id="element-138">Email</p>
                <a href="mailto:info@planesmart.com" className="hover:text-brand-400 transition-colors" data-id="element-139">
                  info@planesmart.com
                </a>
              </li>
              <li data-id="element-140">
                <p className="text-white font-medium mb-1" data-id="element-141">Headquarters</p>
                <p data-id="element-142">
                  Addison Airport (KADS)
                  <br data-id="element-143" />
                  Dallas, TX
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-500" data-id="element-144">
          <p data-id="element-145">© {new Date().getFullYear()} PlaneSmart. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-146">
            <a href="#" className="hover:text-white transition-colors" data-id="element-147">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-148">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}